import {ReactNode} from 'react';
import {AlertCircle, TriangleAlert} from 'lucide-react';
import {Container, Content, StyledIcon} from './styled';

enum AlertTypes {
  INFO,
  WARNING,
}

enum AlertSizes {
  S,
  M,
  L,
}

const getIcon = (type: AlertTypes) =>
  ({
    [AlertTypes.INFO]: <AlertCircle size={24} />,
    [AlertTypes.WARNING]: <TriangleAlert size={24} />,
  }[type]);

type Props = {
  text: string | JSX.Element;
  type?: AlertTypes;
  size?: AlertSizes;
  withIcon?: boolean;
  className?: string;
  customIcon?: ReactNode;
};

const AlertBox = ({
  text,
  className = '',
  withIcon = true,
  size = AlertSizes.L,
  type = AlertTypes.INFO,
  customIcon,
}: Props) => {
  const isIconVisible = Boolean(withIcon || customIcon);

  return (
    <Container type={type} size={size} className={className}>
      {isIconVisible && (
        <StyledIcon size={size}>{customIcon || getIcon(type)}</StyledIcon>
      )}
      <Content className="alert__content">{text}</Content>
    </Container>
  );
};

export {AlertBox, AlertTypes, AlertSizes};
